import React, { useState, useEffect } from "react";
import axios from "axios";
import { data, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Card from "../../Components/Cards/Card";
import PlanCard from "../../Components/Cards/PlanCard";
import ProgressBar from "../../Components/ProgressBar";
import Images from "../../Assets/Images";
import Api from "../../Api/Api";
import postApi from "../../Api/PostApi";

function Steeper() {
  const [planValue, setPlanValue] = useState(0);
  const navigate = useNavigate();
  const [plan, setPlan] = useState([]);
  const location = useLocation();
  const email = location.state?.email || "";
  const [country, setCountry] = useState("");
  const [template, setTemplate] = useState([]);
  const [profile, setProfile] = useState({
    name: "",
    about: "",
    logo: "",
  });
  const [image, setImage] = useState(null);
  const [selectedGoal, setSelectedGoal] = useState(null);

  const [selectedPlan, setSelectedPlan] = useState(null);

  const [goal, setGoal] = useState([]);

  const [selectedTemplate, setSelectedTemplate] = useState(null);

  useEffect(() => {
    Api.api("http://192.168.0.110:8000/admin_api/goals").then((data) =>
      setGoal(data.rows)
    );

    Api.api("http://192.168.0.110:8000/admin_api/templates").then((data) =>
      setTemplate(data.rows)
    );

    Api.api("http://192.168.0.110:8000/admin_api/plans").then((data) =>
      setPlan(data.rows)
    );
  }, []);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setProfile({ ...profile, logo: reader.result });
      };
      reader.readAsDataURL(file);
    }
  };
  const handlPlan = () => {
    setPlanValue(2);
  };
  const handlGoal = () => {
    setPlanValue(1);
  };
  const handleTemplate = () => {
    setPlanValue(3);
  };

  const dataURLtoFile = (dataUrl, filename) => {
    const arr = dataUrl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  };
  fetch("https://ipinfo.io/json")
    .then((response) => response.json())
    .then((data) => {
      const country = data.country;
      setCountry(country);
      console.log("Current country:", country);
    })
    .catch((error) => console.error("Error fetching country:", error));

  const handleSubmit = async () => {
    const formData = new FormData();
    formData.append("name", profile.name);
    formData.append("about", profile.about);
    formData.append("logo", dataURLtoFile(profile.logo, "logo.png"));
    formData.append("email", "fffss@gmai.com");
    formData.append("country", country);
    formData.append("plan_id", selectedPlan);
    formData.append("goals_id", selectedGoal);
    formData.append("template_id", selectedTemplate);

    const apiUrl = "http://192.168.0.110:8000/api/v1/register";

    const response = await postApi(apiUrl, formData, true);

    if (response.status === true) {
      localStorage.setItem("Token", response.token);
      navigate("/MenuCard");
    }
  };

  return (
    <div>
      {planValue === 0 && (
        <div>
          <div className="logo-page">
            <img src={Images.logo} className="" />
          </div>
          <div className="logo">
            <img src={Images.logo_bg} />
          </div>
          <div className="container-goal">
            <ProgressBar
              steps={[
                { label: "Step 1" },
                { label: "Step 2" },
                { label: "Step 3" },
                { label: "Step 4" },
              ]}
              activeStep={0}
            />
            <h1 className="heading res">
              Describe Your Goal <br /> for using{" "}
              <span className="highlight">QFlyers</span>
            </h1>

            <p>This helps us personalize your experience</p>
            <div className="goal-container">
              {goal.map((card) => (
                <Card
                  key={card.id}
                  data={card}
                  isSelected={selectedGoal === card.id}
                  onSelect={() => setSelectedGoal(card.id)}
                />
              ))}
            </div>
            <div className="btn-container fixed">
              <button className="btn-continue" onClick={handlGoal}>
                Continue
              </button>
            </div>
          </div>
        </div>
      )}

      {planValue == 1 && (
        <div>
          <div className="logo-page">
            <img src={Images.logo} className="" />
          </div>
          <div className="logo">
            <img src={Images.logo_bg} />
          </div>
          <div className="container-goal">
            <ProgressBar
              steps={[
                { label: "Step 1" },
                { label: "Step 2" },
                { label: "Step 3" },
                { label: "Step 4" },
              ]}
              activeStep={1}
            />
            <h1 className="heading">Find the plan for you</h1>
            <p>You can change at any time</p>
            <div className=" plancenter grid-container">
              {plan.map((plans) => (
                <PlanCard
                  key={plans.id}
                  plan={plans}
                  isSelected={selectedPlan === plans.id}
                  onSelect={() => setSelectedPlan(plans.id)}
                />
              ))}
            </div>
            <div className="btn-container fixed">
              <button className="btn-continue " onClick={handlPlan}>
                Continue
              </button>
            </div>
          </div>
        </div>
      )}

      {planValue == 2 && (
        <div>
          <div className="logo-page">
            <img src={Images.logo} className="" />
          </div>
          <div className="logo">
            <img src={Images.logo_bg} />
          </div>
          <div className="container-goal">
            <ProgressBar
              steps={[
                { label: "Step 1" },
                { label: "Step 2" },
                { label: "Step 3" },
                { label: "Step 4" },
              ]}
              activeStep={2}
            />
            <h1 className="heading">Select a template</h1>
            <div className="template-container">
              {template.map((tem) => (
                <div
                  key={tem.id}
                  className={`img-container border-2 rounded-lg p-2 ${
                    selectedTemplate === tem.id
                      ? "border-blue-500"
                      : "border-gray-300"
                  }`}
                  onClick={() => setSelectedTemplate(tem.id)}
                >
                  <img
                    src={tem.image}
                    alt="Template"
                    className="w-full h-auto rounded-lg cursor-pointer"
                  />
                </div>
              ))}
            </div>
            <div className="btn-container fixed">
              <button className="btn-continue  " onClick={handleTemplate}>
                Continue
              </button>
            </div>
          </div>
        </div>
      )}

      {planValue == 3 && (
        <div>
          <div className="logo-page">
            <img src={Images.logo} className="" />
          </div>
          <div className="logo">
            <img src={Images.logo_bg} />
          </div>
          <div className="container-goal">
            <ProgressBar
              steps={[
                { label: "Step 1" },
                { label: "Step 2" },
                { label: "Step 3" },
                { label: "Step 4" },
              ]}
              activeStep={3}
            />
            <h1 className="heading">Select a profile image</h1>
            <div className="plan-container">
              <div className="d-flex gap-3">
                <div className="cricle ">
                  {" "}
                  <img src={Images.ava1} alt="Selected" className=" cricle" />
                </div>
                <div className="cricle ">
                  <img src={Images.ava2} alt="Selected" className=" cricle" />
                </div>
                <div className="cricle ">
                  <img src={Images.ava3} alt="Selected" className=" cricle" />
                </div>

                <label htmlFor="fileInput" className="">
                  {image ? (
                    <img src={image} alt="Selected" className=" cricle" />
                  ) : (
                    <div>
                      <div className="cricle ">
                        {" "}
                        <p style={{ fontSize: "14px" }}>Select a photo</p>
                      </div>
                    </div>
                  )}
                  <input
                    id="fileInput"
                    type="file"
                    accept="image/*"
                    className="hidden"
                    hidden
                    onChange={handleFileChange}
                  />
                </label>
              </div>

              <input
                type="text"
                value={profile.name}
                placeholder="Profile title"
                onChange={(e) =>
                  setProfile({ ...profile, name: e.target.value })
                }
              />
              <textarea
                className="mt-3"
                placeholder="Bio"
                rows="5"
                value={profile.about}
                onChange={(e) =>
                  setProfile({ ...profile, about: e.target.value })
                }
              ></textarea>
            </div>
            <div className="btn-container fixed">
              <button className="btn-continue mt-3 " onClick={handleSubmit}>
                Continue
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Steeper;
